import {createSelector} from 'reselect';
import props from '../props';

export default createSelector(
    props.user.user,
    props.games.games,
    props.games.history,
    props.user.logins,
    props.modals.data.cashout_failed,
    props.games.sessions,
    (user, games, history, logins, data, sessions) => {
        const transaction = history.list.filter(h => h.transactionId === data.transactionId)[0] || false,
              game = transaction ? games.filter(g => g.slug === transaction.game)[0] || false : false,
              login = transaction ? logins.filter(l => l.login === transaction.login)[0] || false : false;

        return {
            user,
            transaction,
            game,
            login,
            reason: data.reason,
            param: data.param,
            sessions
        }
    }
)